import React from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Row } from "react-flexbox-grid/lib/index";
import {
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Button,
  Typography
} from "@material-ui/core";
import Refresh from "@material-ui/icons/Refresh";
import FilesListTable from "./FilesListTable";

const FilesListCard = props => (
  <Card>
    <CardHeader title="Select the annotated files you want to review." />
    <CardContent>
      <Typography component="p" style={{ marginBottom: 7 }}>
        The 50 most recently annotated files are displayed here by default.
        Expand the Search Options above to search by date or by unit number.
      </Typography>
      <Typography display="block" style={{ marginBottom: 10 }}>
        When searching by date or unit number, results are limited to 200 files.
        Please contact IT if you need to review a file that is not shown.
      </Typography>
      <Row center="xs">
        <ContainerDimensions>
          <FilesListTable {...props} />
        </ContainerDimensions>
      </Row>
    </CardContent>
    <CardActions>
      <Button
        variant="text"
        onClick={props.onFilesRefreshClick}
        color="secondary"
        style={{ paddingTop: "10px", marginLeft: "auto" }}
      >
        Refresh
        <Refresh />
      </Button>
    </CardActions>
  </Card>
);

FilesListCard.propTypes = {
  onFilesRefreshClick: PropTypes.func.isRequired
};

export default FilesListCard;
